import React from "react";

export default (props) => {
  const selector = (props.type === 'major') ?
                    'major-divider' : 'minor-divider';
  return (
    <hr className={selector} />
  );
}